// @ts-nocheck
// import useGoogleMaps from "@insite/client-framework/Common/Hooks/useGoogleMaps"; // Starter Custom Code
import { LocationGoogleMapMarkerType } from "@insite/client-framework/Common/Hooks/useLocationGoogleMarkers";
import withDynamicGoogleMaps from "@insite/client-framework/Common/withDynamicGoogleMaps";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { DistanceUnitOfMeasure } from "@insite/content-library/Components/DistanceDisplay";
import LocationGoogleMap, { LocationGoogleMapStyles } from "@insite/content-library/Components/LocationGoogleMap";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useContext } from "react";
import { connect } from "react-redux";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { locationProps } from "@store/Themes/common/props/location";
import useGoogleMapMarkerIconByType from "@toolkit/Framework/Common/Hooks/googleMap/useGoogleMapMarkerIconByType";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import useGoogleMaps from "@toolkit/Modules/client-framework/Common/Hooks/useGoogleMaps";
import { css } from "styled-components";
/* Starter Custom Code - End */

interface OwnProps {
    useLoadScript: ({ googleMapsApiKey }: { googleMapsApiKey: any }) => { isLoaded: boolean };
}

const mapStateToProps = (state: ApplicationState) => ({
    googleMapsApiKey: getSettingsCollection(state).websiteSettings.googleMapsApiKey,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface DealerLocationMapStyles {
    locationGoogleMap?: LocationGoogleMapStyles;
    // Starter Custom Code
    mapWrapper?: InjectableCss;
}

export const dealerLocationMapStyles: DealerLocationMapStyles = {
    mapWrapper: mergeProps<DealerLocationMapStyles["mapWrapper"]>(locationProps.mapWrapper, {
        css: css`
            height: ${pxToRem(400)};
        `,
    }),
};

const styles = dealerLocationMapStyles;

const DealerLocationMap: React.FC<Props> = ({ googleMapsApiKey, useLoadScript }) => {
    const { value: dealer } = useContext(DealerStateContext);
    const { isLoaded } = useLoadScript({ googleMapsApiKey });
    const { setGoogleMap, isGoogleMapsScriptsLoaded } = useGoogleMaps({
        isLoaded,
        isShown: true,
    });

    const MarkerIcon = useGoogleMapMarkerIconByType("SELECTED", undefined, true); // Starter Custom Code

    if (!dealer || !isGoogleMapsScriptsLoaded) {
        return null;
    }

    const mapMarkersElement = {
        key: dealer.id,
        locationId: dealer.id,
        position: new google.maps.LatLng(dealer.latitude, dealer.longitude),
        type: "SELECTED" as LocationGoogleMapMarkerType,
        icon: MarkerIcon, // Starter Custom Code
        onClick: () => {},
    };

    return (
        <StyledWrapper {...styles.mapWrapper} /* Starter Custom Code */>
            <LocationGoogleMap
                extendedStyles={styles.locationGoogleMap}
                currentLocation={mapMarkersElement.position}
                distanceUnitOfMeasure={dealer.distanceUnitOfMeasure as DistanceUnitOfMeasure}
                setGoogleMap={setGoogleMap}
                mapMarkerElements={[mapMarkersElement]}
                locationSearchFilter=""
                handleOpenLocationContent={() => {}}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withDynamicGoogleMaps(DealerLocationMap)),
    definition: {
        allowedContexts: ["DealerDetailsPage"],
        group: "Dealer Details",
    },
};

export default widgetModule;
